import { render, staticRenderFns } from "./BurgerButton.vue?vue&type=template&id=2080ac79&"
import script from "./BurgerButton.vue?vue&type=script&lang=js&"
export * from "./BurgerButton.vue?vue&type=script&lang=js&"
import style0 from "./BurgerButton.vue?vue&type=style&index=0&id=2080ac79&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports